import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import { Form, InputGroup } from "react-bootstrap";


import moment from "moment/moment";


export default function ViewProduct() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState({
        name: "",
        code: "",
        supplierId: 0,
        costPriceSummer: 0,
        salePriceSummer: 0,
        haulageRateSummer: 0,
        costPriceWinter: 0,
        salePriceWinter: 0,
        haulageRateWinter: 0,
        type: ""
    });
    const [orders, setOrders] = useState([]);
    const [pricingContracts, setPricingContracts] = useState([]);
 
    useEffect(() => {
        

        // Load the product details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Product:", res.data);
                setProduct(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });
    }, [])

    useEffect(() => {
        console.log("product:", product)
        if (product.code != '') {

            // Load any recent orders for the product
            axios
                .get(`https://${process.env.REACT_APP_IP}/api/products/${product.supplierId}/${product.code}/orders`, {
                    headers: { Authorization: `bearer ${user.token}` },
                })
                .then((res) => {
                    console.log("Recent orders:", res.data);
                    setOrders(res.data);

                })
                .catch((err) => {
                    console.log(err);


                    if (err.response.status === 401) {
                        dispatch({ type: "LOGOUT" })
                        navigate("../")
                    }
                });

            // Load any pricing contracts for this product
            axios
                .get(`https://${process.env.REACT_APP_IP}/api/products/${product.id}/pricingcontracts`, {
                    headers: { Authorization: `bearer ${user.token}` },
                })
                .then((res) => {
                    console.log("Pricing Contracts:", res.data);
                    setPricingContracts(res.data);

                })
                .catch((err) => {
                    console.log(err);


                    if (err.response.status === 401) {
                        dispatch({ type: "LOGOUT" })
                        navigate("../")
                    }
                });
        }
    }, [product])

    

   

    return (
        <div className="page">

            <div className="row">
                <div className="col-12">
                    <h1>
                        {product && product.name}

                        {/* Edit Button */}
                        <Link to={`/Products/Edit/${product.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>

                    </h1>
                </div>
            </div>

           

            
            <div className="row">
                {/* Contact Details */}
                <div className="col-md-5">

                    <div className="row">
                        <div className="col-12">
                            <h3>Product Details</h3>
                        </div>
                    </div>

                   

                    { /* Code */}
                    <div className="row">
                        <div className="col-4">
                            Code
                        </div>
                        <div className="col-8">
                            {product.code}
                        </div>
                    </div>


                    { /* Product Name */}
                    <div className="row">
                        <div className="col-4">
                            Name
                        </div>
                        <div className="col-8">
                            {product.name}
                        </div>
                    </div>

                    { /* Product Type */}
                    <div className="row">
                        <div className="col-4">
                            Product Type
                        </div>
                        <div className="col-8">
                            {product.type}
                        </div>
                    </div>

                    { /* Supplier */}
                    <div className="row">
                        <div className="col-4">
                            Supplier
                        </div>
                        <div className="col-8">
                            {product.supplierName}
                        </div>
                    </div>

                </div>

                {/* Pricing Details */}
                <div className="col-md-7">

                    <div className="row">
                        <div className="col-12">
                            <h3>Pricing Details</h3>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-4">
                            
                        </div>
                        <div className="col-4">
                            Summer
                        </div>
                        <div className="col-4">
                            Winter
                        </div>
                    </div>

                    { /* Cost Price */}
                    <div className="row">
                        <div className="col-4">
                            Cost Price
                        </div>
                        <div className="col-4">
                            &pound;{product.costPriceSummer.toFixed(2)}
                        </div>
                        <div className="col-4">
                            &pound;{product.costPriceWinter.toFixed(2)}
                        </div>
                    </div>

                    { /* Sale Price */}
                    <div className="row">
                        <div className="col-4">
                            Sale Price
                        </div>
                        <div className="col-4">
                            &pound;{product.salePriceSummer.toFixed(2)}
                        </div>
                        <div className="col-4">
                            &pound;{product.salePriceWinter.toFixed(2)}
                        </div>
                    </div>

                    { /* Haulage Rate */}
                    <div className="row">
                        <div className="col-4">
                            Haulage Rate
                        </div>
                        <div className="col-4">
                            &pound;{product.haulageRateSummer.toFixed(2)}
                        </div>
                        <div className="col-4">
                            &pound;{product.haulageRateWinter.toFixed(2)}
                        </div>
                    </div>
               
                    { /* Pricing Contracts */ } 
                    <div className="row">
                        <div className="col-12">
                            <h3>Pricing Contracts

                                <Link to={`/PricingContracts/Create/?supplierId=${product && product.supplierId}&productId=${product && product.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Create</Link>
                            </h3>
                            
                        </div>
                    </div>

                    <div style={{ fontSize: 14 }}>
                        <div className="row" style={{ borderBottom: "1px solid #ccc" } }>
                        <div className="col-4">
                           Customer
                        </div>
                        <div className="col-2">
                            Cost Price
                        </div>
                        <div className="col-2">
                            Sale Price
                        </div>
                        <div className="col-2">
                            Haulage Rate
                        </div>
                    </div>

                    {pricingContracts && pricingContracts.length > 0 && ( 
                            pricingContracts.map((contract) => (
                                <div style={{ borderBottom: "1px solid #ccc", marginTop: 10, paddingBottom: 10 }}>
                                    <div className="row">
                                        <div className="col-4">
                                            {contract.customer.name}<br />
                                            
                                        </div>
                                        <div className="col-2">
                                            &pound;{contract.costPriceSummer.toFixed(2)} / &pound;{contract.costPriceWinter.toFixed(2)}
                                        </div>
                                        <div className="col-2">
                                            &pound;{contract.salePriceSummer.toFixed(2)} / &pound;{contract.salePriceWinter.toFixed(2)}
                                        </div>
                                        <div className="col-2">
                                            &pound;{contract.haulageRateSummer.toFixed(2)} / &pound;{contract.haulageRateWinter.toFixed(2)}
                                        </div>
                                        <div className="col-2">
                                            <Link to={`/PricingContracts/Edit/${contract.id}`} className="btn-sm btn-other">Edit</Link>
                                        </div>
                                    </div>
                                   
                                        <div className="row">
                                            <div className="col-4">{moment(contract.startDate).format("DD/MM/YYYY")} - {contract.endDate ? moment(contract.endDate).format("DD/MM/YYYY") : "Ongoing"}</div>
                                        <div className="col-8">
                                            {contract.tonnageAllowed > 0 && (
                                                <span>
                                            Allowed: {contract.tonnageAllowed.toFixed(2)} Remaining: {(contract.tonnageAllowed - contract.tonnageUsed).toFixed(2)}
                                                </span>
                                            
                                            )}
                                        
                                        </div>
                                    </div>
                                    


                                </div>
                        )) 
                    
                    )}
                </div>
            </div>

        </div>
            
            

                <div className="row">
                <div className="col-md-6">

                    <div className="row">
                        <div className="col-12">
                            <h3 style={{ marginTop: 20 }}>Recent Orders</h3>
                        

                    {(orders && orders.length > 0) && (
                        <table width="100%" style={{ marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Order No</th>
                                    <th>Qty Ordered</th>
                                    <th>Cost Price</th>
                                    <th>Sale Price</th>
                                </tr>
                            </thead>
                            <tbody>

                                {orders.map((order) => ( 

                                    <tr key={order.id} style={{ cursor: "pointer" }}>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>{moment(order.orderDate).format("DD/MM/YYYY")}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>{order.orderNumber}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>{order.quantityOrdered}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>&pound;{order.costPrice.toFixed(2)}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>&pound;{order.salePrice.toFixed(2)}</td>
                                    </tr>

                                ))}
                            </tbody>
                        </table>
                    )}
                    {(orders.length == 0) && (
                        <em>No orders found for this product</em>
                            )}
                        </div>
                    </div>
                    </div>
                </div>
            
           

            

        </div>
  )
}
